import type { PermissionCode } from '@/shared/permissions';

/**
 * Loyalty permission codes — mirror the BFF's `RolePermissionMapper`:
 *  - `loyalty.view` — read bonus accounts, transactions, cards, tiers and rules
 *  - `loyalty.manage` — accrue/redeem points, issue cards, configure tiers/rules
 *
 * This is the top-level `loyalty.*` namespace, distinct from `settings.*`
 * (which does NOT grant these).
 */
export const LOYALTY_PERMISSIONS = {
  loyalty: { view: 'loyalty.view', manage: 'loyalty.manage' },
} as const satisfies Record<string, Record<string, PermissionCode>>;

export type LoyaltyPermissionArea = keyof typeof LOYALTY_PERMISSIONS;

/** Flattened list of every loyalty permission code (for mock sessions / seeding). */
export const ALL_LOYALTY_PERMISSIONS: PermissionCode[] = Object.values(LOYALTY_PERMISSIONS).flatMap(
  (area) => Object.values(area),
);
